/**
 * @generated SignedSource<<e44997c1b46b733d9f29818ca7dbdebf>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderInlineDataFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type initSierraChat_seller$data = {
  readonly serviceId: string | null;
  readonly sfChatToken: string | null;
  readonly token: string | null;
  readonly " $fragmentType": "initSierraChat_seller";
};
export type initSierraChat_seller$key = {
  readonly " $data"?: initSierraChat_seller$data;
  readonly " $fragmentSpreads": FragmentRefs<"initSierraChat_seller">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "initSierraChat_seller"
};

(node as any).hash = "866945a39288065e56ea0b3060c36a4a";

export default node;
